import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, IconButton, Typography } from '@mui/material';
import Modal from '@mui/material/Modal';
import React, { useState } from 'react';
import ModalFeedBack from '../../../components/ModalFeedBack';
import { ModalAgendamentoProps } from '../../../interfaces/props/ModalAgendamentoProps';
import { confirmarAgendamento } from '../../../services/AgendamentoService';
import ModalAtendimentoConfirmado from './ModalAtendimentoConfirmado';
import './styles.css';
import { sxButtonScheduleAction, sxCloseIconButton, sxTypographySubTitleModal, sxTypographyTitleModal } from './sxProps';
import LoadingApp from '../../../components/LoadingApp';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';

const ModalConfirmarAgendamento: React.FC<ModalAgendamentoProps> = ({ showModal, handleShowModal, agendamento, onComplete }) => {

    const [showModalAtendimentoConfirmado, setShowModalAtendimentoConfirmado] = useState<boolean>(false);
    const [showModalFeedBack, setShowModalFeedBack] = useState<boolean>(false);
    const [showLoading, setShowLoading] = useState<boolean>(false);

    const accessibility = useAccessibility();

    const handleConfirmarConfirmacaoAtendimento = async () => {
        handleShowModal();
        if (agendamento) {
            setShowLoading(true);
            let idInstal = parseInt(agendamento.idInstal, 10);
            let idAgendamento = parseInt(agendamento.id, 10);
            let response = await confirmarAgendamento(idInstal, idAgendamento, 'canal-pf');
            setShowLoading(false);
            if (response?.status !== 200 || response.data === 'Confirmacao nao realizada.') {
                handleShowModalFeedBack();
            } else {
                handleShowAtendimentoConfirmado();
            }
            onComplete();
        }
    }

    const handleShowAtendimentoConfirmado = () => {
        setShowModalAtendimentoConfirmado(showModalAtendimentoConfirmado => !showModalAtendimentoConfirmado);
    }

    const handleShowModalFeedBack = () => {
        setShowModalFeedBack(showModalFeedBack => !showModalFeedBack);
    }

    return (
        <div>
            <Modal
                open={showModal}
                onClose={handleShowModal}
            >
                <div className='container-schedule-modal' style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility }}>
                    <IconButton
                        aria-label="close"
                        onClick={handleShowModal}
                        sx={sxCloseIconButton}
                    >
                        <FontAwesomeIcon style={accessibility.textStyleAccessibility} icon={faTimes} size="1x" color='black' />
                    </IconButton>
                    <div>
                        <Typography style={accessibility.textStyleAccessibility} tabIndex={0} sx={sxTypographyTitleModal}>Confirmar atendimento</Typography>
                        <Typography style={accessibility.textStyleAccessibility} tabIndex={0} sx={sxTypographySubTitleModal}>Gostaria de confirmar seu atendimento?</Typography>
                    </div>
                    <div className='schedule-modal-buttons-holder'>
                        <Button onClick={handleConfirmarConfirmacaoAtendimento} style={accessibility.buttonStyleAccessibility} variant='contained' sx={sxButtonScheduleAction}>
                            <Typography style={accessibility.buttonTextStyleAccessibility} tabIndex={0}>Confirmar</Typography>
                        </Button>
                        <Button onClick={handleShowModal} variant='outlined' style={accessibility.textStyleAccessibility} sx={sxButtonScheduleAction}>
                            <Typography style={accessibility.buttonTextStyleAccessibility} tabIndex={0}>Cancelar</Typography>
                        </Button>
                    </div>
                </div>
            </Modal>
            <ModalAtendimentoConfirmado
                handleShowModal={handleShowAtendimentoConfirmado}
                showModal={showModalAtendimentoConfirmado}
            />
            <ModalFeedBack
                showModal={showModalFeedBack}
                handleButtonModal={handleShowModalFeedBack}
                showButtonModal
                icon='error'
                handleShowModal={handleShowModalFeedBack}
                textButton='Voltar para agendamentos'
                title='Erro'
                subTitle='Ocorreu um erro ao confirmar seu agendamento, tente novamente em alguns instantes'
            />
            <LoadingApp showLoading={showLoading}/>
        </div>
    );
};

export default ModalConfirmarAgendamento;
